import type { ElementType } from "react";
import type { ActionButtonProps } from "@sb1/ffe-buttons-react";
import { ActionButton as FellesActionButton } from "@sb1f/buttons";
import { getCustomData } from "~/utils/tracking/utils";

type Props<As extends ElementType = "button"> = ActionButtonProps<As> & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const ActionButton = <As extends ElementType = "button">({ track = true, trackingData, ...props }: Props<As>) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesActionButton customData={customData} {...props} />;
};

export default ActionButton;
